import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import './index.css'

const Header = ({ login, emailVerified, userName }) => {
  let items = []
  if (login) {
      items.push(<li key='2'><NavLink exact to='/db'>Akce</NavLink></li>)
    items.push(<li key='1'><NavLink to='/user'>Uživatel: <span className='userName'>{userName}</span></NavLink></li>)
  } else {
    items.push(<li key='3'><NavLink to="/login">Přihlásit se</NavLink></li>)
  }
  return (
    <div className='mHead'>
      <h2 className='mHead-h2'><Link to="/">Dadopa</Link></h2>
      <ul className='mHead-ul'>
        {items}
        <li className='mHead-ul-li'><a href='https://jesyka.cz/dadopa-pruvodce-uzivatele/' target='blank'>Nápověda</a></li>
      </ul>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/AppHeader/indexC.js